/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Enum for user activity types
 */
export type UserActivityType = (typeof UserActivityType)[keyof typeof UserActivityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserActivityType = {
  open_module: 'open_module',
  open_task: 'open_task',
  close_task: 'close_task',
  complete_task: 'complete_task',
  submit_module: 'submit_module',
  store_draft: 'store_draft',
  login: 'login',
  impersonate: 'impersonate',
} as const;
